import { createStyles } from '@material-ui/styles';
import { mediumGray } from 'theme/colors';

export default () =>
  createStyles({
    link: {
      fontSize: 13,
      textDecoration: 'none',
      color: mediumGray,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    logo: {
      height: '35px',
    },
  });
